import { useInfiniteQuery } from 'react-query';
import { AxiosError } from 'axios';

import { VideoCommentsResponse } from '@common/types/api';
import { api } from '@services';

type SortOrder = 'newest' | 'oldest';

const COMMENTS_PER_PAGE = 10;

const fetchVideoComments = async (
  videoId: number,
  page: number,
  sort: SortOrder,
): Promise<VideoCommentsResponse> => {
  const { data } = await api.get<VideoCommentsResponse>(
    `videos/${videoId}/comments`,
    { params: { page, limit: COMMENTS_PER_PAGE, sort } },
  );

  return data;
};

export const useVideoCommentsQuery = (
  videoId: number,
  sort: SortOrder = 'newest',
) =>
  useInfiniteQuery<VideoCommentsResponse, AxiosError>(
    ['video-comments', String(videoId), sort],
    ({ pageParam = 1 }) => fetchVideoComments(videoId, pageParam, sort),
    {
      getNextPageParam: (lastPage) => {
        const { current_page, total_pages } = lastPage.meta.pagination;
        return current_page < total_pages ? current_page + 1 : undefined;
      },
    },
  );
